import { getCompareRoute } from 'asset-actions-lib/utils/routes';
import { ACTION_IDS } from 'asset-actions-lib/constants/actionIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const COMPARE_ACTION = {
  id: ACTION_IDS.COMPARE,
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "assetActionsLib.sharedActions.compare"
  }),
  onConfirm: crmObject => {
    window.open(getCompareRoute(crmObject));
  },
  actionGroup: 1
};